import {BrowserRouter, Route, Switch, withRouter, useLocation} from 'react-router-dom';
import React, { useEffect } from "react";
import Home from './Home';
import InvestorHome from './InvestorHome';
import OurApproach from './OurApproach';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Dashboard from './Dashboard';
import TradeDashboard from './TradeDashboard';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import Header from './components/TradingCommand/Header';
import Footer from './footer';
import Liveview from './Live';
import LiveSocket from './LiveSocket';
import TradingCommand from './TradingCommand';
import DailyDetailDashboard from './DailyDetailDashboard';
import AdminPage from './routes/admin/admin';
import MyTrades from './follower/myTrades';
import ReactGA from 'react-ga4';
import { initGA, logPageView } from './service/StatCounter';

initGA('G-ES7SDYBBEQ');

const TrackedRoute = withRouter(Route);

const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        console.log("location:", location);
        logPageView(location.pathname);
    }, [location]);

    return null;
};

function App() {
    return (
        <div className="App">
        <BrowserRouter>
        <Header />
        <div className="content">
        <Switch>
        {/* Public — anyone */}
        <TrackedRoute exact path="/"          component={Home} />
        <TrackedRoute exact path="/Home"       component={Home} />
        <TrackedRoute path="/approach"         component={OurApproach} />
        <TrackedRoute path="/investors"        component={InvestorHome} />
        <PublicRoute  path="/Signup"           component={Register} />
        <PublicRoute  path="/Login"            component={Login} />
        <PublicRoute  path="/forgot-password"  component={ForgotPassword} />
        <PublicRoute  path="/reset-password"   component={ResetPassword} />

        {/* Follower + admin */}
        <PrivateRoute path="/myTrades"    component={MyTrades}             allowedRoles={["follower","admin","demo"]} />

    {/* Admin + demo */}
<PrivateRoute path="/Dashboard"   component={Dashboard}            allowedRoles={["admin","demo"]} />
<PrivateRoute path="/trading"     component={TradeDashboard}       allowedRoles={["admin","demo"]} />
<PrivateRoute path="/DailyDetail" component={DailyDetailDashboard} allowedRoles={["admin","demo"]} />
<PrivateRoute path="/Live"        component={LiveSocket}            allowedRoles={["admin","demo"]} />
<PrivateRoute path="/Live-New"    component={TradingCommand}        allowedRoles={["admin","demo"]} />

    {/* Admin only */}
<PrivateRoute path="/Admin"       component={AdminPage}            allowedRoles={["admin"]} />
        </Switch>
        <RouteTracker/>
        </div>
        <Footer/>
        </BrowserRouter>
        </div>
);
}

export default App;